import {
  MODE_CALCUL_MANUEL,
  TYPOLOGIE_GROUPE,
  TYPOLOGIE_POINT_DE_VENTE,
} from '@/configuration/tiers/tiersConf';
import { get as getTiers } from '@/api/tiers/index';
import { CATEGORIE_DIVERS, CATEGORIE_REGROUPEMENT } from '@/configuration/catalogue/produitConf';
import genererModeCalculHonoraire from '@/services/commun/tiers/genererModeCalculHonoraire';
import { UNITE } from '@/configuration/devisConf';

function setModeCalculHonoraire(listeLignesCommande, modeCalcul) {
  listeLignesCommande
    .filter((ligneCommande) => {
      return ligneCommande.type === CATEGORIE_REGROUPEMENT
        && ligneCommande.lignesCommande && ligneCommande.lignesCommande.length !== 0;
    })
    .forEach((ligneRegroupement) => {
      ligneRegroupement.lignesCommande.forEach((ligneEnfant) => {
        if (ligneEnfant.typeProduit === CATEGORIE_DIVERS
          && ligneEnfant.produit.produitDivers && ligneEnfant.produit.produitDivers.honoraire) {
          ligneEnfant.quantite = 1;
          ligneEnfant.uniteVente = UNITE;
          ligneEnfant.modeCalculHonoraire = modeCalcul;
          ligneEnfant.calculAutomatiqueTlpe = modeCalcul.modeCalcul !== MODE_CALCUL_MANUEL;
        }
      });
    });
}
export default async function updateModeCalculHonoraireLigneCommandeHonoraire(
  listeLignesCommande, intervenants,
) {
  const lignesCommandes = listeLignesCommande || [];
  const annonceur = intervenants.find((intervenant) => { return intervenant.annonceur; });
  if (!annonceur || annonceur.typologie === TYPOLOGIE_GROUPE) {
    setModeCalculHonoraire(lignesCommandes, genererModeCalculHonoraire());
    return;
  }

  let enseigne = null;
  if (annonceur.tiers.typologie === TYPOLOGIE_POINT_DE_VENTE && annonceur.tiers.tiersParentId) {
    enseigne = annonceur.tiersParent
      ? annonceur.tiers.tiersParent
      : (await getTiers(annonceur.tiers.tiersParentId)).data.result;
  } else enseigne = annonceur;
  if (!enseigne) {
    setModeCalculHonoraire(lignesCommandes, genererModeCalculHonoraire());
    return;
  }
  setModeCalculHonoraire(lignesCommandes, enseigne.tiers
    ? enseigne.tiers.modeCalculHonoraire : enseigne.modeCalculHonoraire);
}
